/**
 * Traduce in italiano gli errori quantità del carrello
 * (Shopify /cart/add e /cart/change rispondono spesso in inglese).
 */
(function () {
  function extractQty(text) {
    var m = String(text).match(/(\d+)/);
    return m ? m[1] : null;
  }

  function isQtyLimit(text) {
    return /maximum quantity|max quantity|you can only add|cannot be added to the cart|already have the maximum|already at its maximum|inventory quantity has been reached|all \d+ .+ are in your cart|can't add more|cannot add more/i.test(
      text
    );
  }

  function translateCartError(raw) {
    if (raw == null) return raw;
    var text = Array.isArray(raw) ? raw.join(' ') : String(raw);
    if (!text.trim()) return raw;
    if (/carrello|quantità massima/i.test(text)) return text;
    if (!isQtyLimit(text)) return text;

    var qty = extractQty(text);
    if (qty) {
      return (
        'Hai raggiunto la quantità massima: puoi avere al massimo ' +
        qty +
        ' pezzi di questo articolo nel carrello.'
      );
    }
    return 'Hai raggiunto la quantità massima di questo articolo nel carrello.';
  }

  function patchToast() {
    if (!window.xoToast || typeof window.xoToast.push !== 'function') return false;
    if (window.xoToast.__respetI18n) return true;
    var original = window.xoToast.push.bind(window.xoToast);
    window.xoToast.push = function (opts) {
      if (opts && typeof opts.content === 'string') {
        opts = Object.assign({}, opts, { content: translateCartError(opts.content) });
      }
      return original(opts);
    };
    window.xoToast.__respetI18n = true;
    return true;
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      return origFetch.apply(this, arguments).then(function (res) {
        if (res.status !== 422) return res;
        if (!/\/cart\/(add|change)/i.test(url)) return res;
        return res
          .clone()
          .json()
          .then(function (data) {
            if (!data || typeof data !== 'object') return res;
            var next = Object.assign({}, data);
            if (typeof next.description === 'string') next.description = translateCartError(next.description);
            if (typeof next.message === 'string') next.message = translateCartError(next.message);
            return new Response(JSON.stringify(next), {
              status: res.status,
              statusText: res.statusText,
              headers: { 'Content-Type': 'application/json' },
            });
          })
          .catch(function () {
            return res;
          });
      });
    };
  }

  function bootToast() {
    if (patchToast()) return;
    window.addEventListener('load', patchToast);
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      if (patchToast() || n > 40) clearInterval(t);
    }, 250);
  }

  bootToast();
})();
